import { Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SoundService } from '../../../../../services/sound/sound.service';

export interface RewardItem {
  id: string;
  name: string;
  rarity: 'Common' | 'Rare' | 'Epic' | 'Legendary';
  imageUrl: string;
  description: string;
}

@Component({
  selector: 'app-loot-opening-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loot-opening-modal.html',
  styleUrl: './loot-opening-modal.scss',
})
export class LootOpeningModal {
  reward = input.required<RewardItem>();
  close = output<void>();

  private soundService = inject(SoundService);

  // State: 'idle' | 'shaking' | 'flash' | 'reveal'
  state = signal<'idle' | 'shaking' | 'flash' | 'reveal'>('idle');

  // Trigger chest opening
  openChest() {
    if (this.state() !== 'idle') return;
    
    // Play ethereal buildup sound
    this.soundService.playChestBuildup(1.8);

    // Step 1: Start shaking
    this.state.set('shaking');

    // Step 2: Trigger screen flash after 1.8 seconds (duration of shake)
    setTimeout(() => {
      this.state.set('flash');
      
      // Play magic arpeggio reveal chime
      this.soundService.playChestReveal();
      
      // Step 3: Reveal reward card after a brief flash peak (200ms)
      setTimeout(() => {
        this.state.set('reveal');
      }, 200);
    }, 1800);
  }

  claimReward() {
    this.close.emit();
  }

  getRarityClass(rarity: string): string {
    switch (rarity) {
      case 'Legendary': return 'rarity-legendary';
      case 'Epic': return 'rarity-epic';
      case 'Rare': return 'rarity-rare';
      default: return 'rarity-common';
    }
  }
}
